module.exports = "varying vec2 vUv;\nuniform float size;\n\nattribute vec3 color;\nvarying lowp vec3 vColor;\n\nvoid main( void ) {\n  vUv = uv;\n  vColor = color;\n  vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n  gl_PointSize = 1000.0 * size / length(mvPosition.xyz);\n  gl_Position = projectionMatrix * mvPosition;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/shaders/star.vert
 ** module id = 243
 ** module chunks = 0
 **/